import {updateToolCall} from "../../../llm/contextManagement/toolCallUpdater.ts";
import {runOrQueueToolCall} from "../../../llm/responseStream/receiver/toolCallHandlers/toolCallFinish/handlers/appToolCallHandler/ide/ideToolCallHandler.ts";
import {addToolMessage} from "../../../llm/responseStream/receiver/toolCallHandlers/toolCallFinish/utils/utils.ts";

export const handleGiveGrepResults = async (data: any, llmRequestRefs: any, websocketRef: any, currentMessageRef: any, messagesSequenceRef: any, setMessages: any, messagesRef: any, updateElementInProgress: any, environmentObjRef: any) => {
    try {
        const matches = JSON.parse(data[0]);
        const toolCallId = data[1];
        const isGatherContext = data[2] === 'true';

        if (isGatherContext) {
            websocketRef.current.send(JSON.stringify({
                functionName: "toolAgent",
                args: {type: "appResults", matches, toolCallId}
            }));

            llmRequestRefs.current.toolCallQueue = llmRequestRefs.current.toolCallQueue.filter((toolCall: any) => toolCall.id !== toolCallId);
            await runOrQueueToolCall(llmRequestRefs, "trigger", environmentObjRef, null, null);
            return;
        }

        if (matches.length > 0) updateToolCall(llmRequestRefs, toolCallId, { matches });

        const { id, name, args } = llmRequestRefs.current.toolCalls[toolCallId];
        addToolMessage({ id, name, args }, { matches }, llmRequestRefs, currentMessageRef, messagesSequenceRef, setMessages, messagesRef);

        updateElementInProgress(toolCallId, 'delete');
        llmRequestRefs.current.toolCallQueue = llmRequestRefs.current.toolCallQueue.filter((toolCall: any) => toolCall.id !== toolCallId);
        await runOrQueueToolCall(llmRequestRefs, "trigger", environmentObjRef, null, null);
    } catch (error) {
        console.error("Error in handleGiveGrepResults:", error);
    }
};